const keys = (t) => [
    {
        key: 'allPages',
        label: t('discover.stats.new_vs_old.chart.allPages'),
        type: 'bar',
    },
    {
        key: 'newPages',
        label: t('discover.stats.new_vs_old.chart.newPages'),
        type: 'bar',
    },
];

export default keys;
